import { render, staticRenderFns } from "./SubstituteCreate.vue?vue&type=template&id=5501cfc7&"
import script from "./SubstituteCreate.vue?vue&type=script&lang=js&"
export * from "./SubstituteCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubstituteCreate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports